<template>
  <div class="title">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr--detailed" style="padding-right: 5px"></i>
        系统标题修改
      </div>
    </div>
    <div class="contnet">
      <div class="left">
        <div class="leftTitle">
          <div class="f-right">
            <div class="flex1 mt10">浏览器标签页名称</div>
          </div>
        </div>
        <div class="leftContent mt10">
          <el-form :model="form" :rules="rules" ref="form">
            <el-form-item label="标签名称" label-width="110px" prop="faviconTitle">
              <el-input placeholder="请输入名称 字数3-15" v-model="form.faviconTitle" clearable></el-input>
            </el-form-item>
            <el-form-item label="上传图片" label-width="110px" prop="faviconUrl">
              <!-- {{form.buildDrawInfoURL}} -->
              <fileUpload
                v-model="form.faviconUrl"
                :uploadData="{ flagType: '0' }"
                :fileType="['jpg', 'png', 'ico']"
                :fileUrl="'/oss/file/uploadFileFlag'"
                :limit="1"
                :fileSize="1"
              />
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="right">
        <div class="leftTitle">
          <div class="f-right">
            <div class="flex1 mt10">监控平台名称</div>
          </div>
        </div>
        <div class="leftContent mt10">
          <el-form :model="form" :rules="rules" ref="form">
            <el-form-item label="平台名称" label-width="110px" prop="iotSystemTitle">
              <el-input placeholder="请输入名称 字数3-15" v-model="form.iotSystemTitle" clearable></el-input>
            </el-form-item>
            <el-form-item label="上传图片" label-width="110px" prop="iotLogoUrl">
              <fileUpload
                v-model="form.iotLogoUrl"
                :uploadData="{ flagType: '0' }"
                :fileType="['jpg', 'png', 'ico']"
                :fileUrl="'/oss/file/uploadFileFlag'"
                :limit="1"
                :fileSize="1"
              />
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

    <div class="contnet2" style="width: 34.5%; margin-top: -60px">
      <div class="leftTitle mt10" style="display: flex">
        <div class="f-right">
          <div class="flex1 mt10">首页名称</div>
        </div>
      </div>
      <div class="leftContent mt10" style="margin-left: 100px">
        <el-form :model="form" :rules="rules" ref="form">
          <el-form-item label="系统标题名称" label-width="110px" prop="homeSystemTitle">
            <el-input placeholder="请输入名称 字数3-15" v-model="form.homeSystemTitle" clearable></el-input>
          </el-form-item>
          <el-form-item label="logo大标题" label-width="110px" prop="homeBigTitle">
            <el-input placeholder="请输入名称 字数3-15" v-model="form.homeBigTitle" clearable></el-input>
          </el-form-item>
          <el-form-item label="logo小标题" label-width="110px" prop="homeSmallTitle">
            <el-input placeholder="请输入名称 字数3-15" v-model="form.homeSmallTitle" clearable></el-input>
          </el-form-item>
          <el-form-item label="上传图片" label-width="110px" prop="homeLogoUrl">
            <fileUpload
              v-model="form.homeLogoUrl"
              :uploadData="{ flagType: '0' }"
              :fileType="['jpg', 'png', 'ico']"
              :fileUrl="'/oss/file/uploadFileFlag'"
              :limit="1"
              :fileSize="1"
            />
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="bot" style="display: flex; flex-direction: column">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="验证码" label-width="110px" prop="code">
          <el-input placeholder="请输入验证码" style="width: 150px" class="yanzhengma" v-model="form.code" clearable @clear="getImg"></el-input>
          <img :src="changeImg" alt="" style="margin-left: 15px" class="imgchange" @click="getImg" />
          <font style="color: #ffa847; margin-left: 10px; cursor: pointer" class="font" @click="getImg">看不清 换一张</font>
        </el-form-item>
      </el-form>
      <div class="btbtn">
        <el-button type="primary" @click="submit(form)">确认</el-button>
        <el-button @click="$router.back()">取消</el-button>
        <!-- <button @click="wan">123123123</button> -->
      </div>
    </div>
  </div>
</template>
<script>
import { changeImg, editName } from '@/api/home';
export default {
  data() {
    return {
      list: [],
      form: {
        checkId: '', // 验证码校验
        code: '', // 验证码
        faviconTitle: '', // 浏览器-标签名称
        faviconUrl: '', //  浏览器-logo图标
        homeBigTitle: '', // 首页-logo大标题
        homeLogoUrl: '', // 首页-左上角logo
        homeSmallTitle: '', // 首页-logo小标题
        homeSystemTitle: '', //  首页-系统名称
        iotLogoUrl: '', //  平台logo
        iotSystemTitle: '', // 品台名称
      },
      changeImg: [],
      rules: {
        faviconTitle: [
          { required: true, message: '请输入标签名称', trigger: 'blur' },
          { min: 3, max: 10, message: '长度在 3 到 15 个字符', trigger: 'blur' },
        ],
        iotSystemTitle: [
          { required: true, message: '请输入平台名称', trigger: 'blur' },
          { min: 3, max: 20, message: '长度在 3 到 15 个字符', trigger: 'blur' },
        ],
        homeSystemTitle: [
          { required: true, message: '请输入系统标题名称', trigger: 'blur' },
          { min: 3, max: 20, message: '长度在 3 到 15 个字符', trigger: 'blur' },
        ],
        homeBigTitle: [
          { required: true, message: '请输入标题名称', trigger: 'blur' },
          { min: 3, max: 10, message: '长度在 3 到 15 个字符', trigger: 'blur' },
        ],
        homeSmallTitle: [
          { required: true, message: '请输入标题名称', trigger: 'blur' },
          { min: 3, max: 20, message: '长度在 3 到 15 个字符', trigger: 'blur' },
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { min: 1, max: 4, message: '长度在 1 到 4 个字符', trigger: 'blur' },
        ],
        iotLogoUrl: [{ required: true, message: '请上传平台logo', trigger: 'blur' }],
        faviconUrl: [{ required: true, message: '请上传浏览器logo', trigger: 'blur' }],
        homeLogoUrl: [{ required: true, message: '请上传首页logo', trigger: 'blur' }],
      },
    };
  },
  mounted() {
    this.getImg();
    this.getList();
  },
  methods: {
    // 获取图片验证码
    getImg() {
      changeImg().then((res) => {
        this.changeImg = 'data:image/gif;base64,' + res.data.img;
        this.form.checkId = res.data.checkId;
      });
    },
    // 数据回显
    getList() {
      editName({ type: 3 }).then((res) => {
        log(res);
        this.form = this.list = res.data;
      });
    },
    // 提交
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.save();
        } else {
          return false;
        }
      });
    },
    // 保存
    save(form) {
      var obj = {
        checkId: this.form.checkId, // 验证码校验
        code: this.form.code, // 系统类型
        faviconTitle: this.form.faviconTitle, // 浏览器-标签名称
        faviconUrl: this.form.faviconUrl, //  浏览器-logo图标
        homeBigTitle: this.form.homeBigTitle, // 首页-logo大标题
        homeLogoUrl: this.form.homeLogoUrl, // 首页-左上角logo
        homeSmallTitle: this.form.homeSmallTitle, // 首页-logo小标题
        homeSystemTitle: this.form.homeSystemTitle, //  首页-系统名称
        iotLogoUrl: this.form.iotLogoUrl, //  平台logo
        iotSystemTitle: this.form.iotSystemTitle, // 品台名称
        type: 3, // 传递数据
      };
      // 浏览器
      this.$put('/system/dict/data/updateIconTitle', obj).then((res) => {
        this.$message({message: res.msg,type: "success", duration: 700,});
        this.$store.commit('setFavicon', obj.faviconUrl);
        this.$store.commit('setTitle', obj.faviconTitle);
        this.$store.state.iotSystemTitle = this.form.iotSystemTitle;
        this.$store.state.iotLogoUrl = this.form.iotLogoUrl;
        setTimeout(() => {
          window.location.reload();
        }, 1000);
        this.$router.back();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.yanzhengma {
  width: 150px !important;
  height: 50px;
}
.contnet {
  width: 100%;
  display: flex;
  .left {
    width: 40%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    .leftTitle {
      display: flex;
      justify-content: flex-start;
    }
    .leftContent {
      display: flex;
      justify-content: space-around;
      align-items: center;
    }
  }
  .right {
    width: 60%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    .leftTitle {
      display: flex;
      justify-content: flex-start;
      padding-left: 100px;
    }
    .leftContent {
      display: flex;
      justify-content: space-around;
      align-items: center;
    }
  }
}
.bottom {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  .leftTitle {
    display: flex;
    justify-content: flex-start;
  }
  .leftContent {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
}
.content2 {
  margin-top: -80px;
  .leftTitle {
    display: flex;
    justify-content: flex-start;
  }
  .leftContent {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
}
.title {
  margin: 1.875rem 1.5rem 0 1.5rem;
  border-left: none;
}
::v-deep .el-upload__tip {
  width: 300px;
}

::v-deep .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
::v-deep .avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.bot {
  display: flex;
  justify-content: space-around;
  flex-direction: row;
  align-items: center;
}
.upload-file {
  display: flex;
}
.imgchange {
  width: 100px;
  height: 40px;
}
.font {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.bbtn {
  height: 73px;
}
</style>
